import React from "react";

import styles from "../../../../styles/secrets-drawers.module.scss";
import { Drawer } from "../../../components/Drawer";
import { Textarea } from "../../../components/Textarea";
import { Button } from "../../../components/Button";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";


export default class OpenDeliveryDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            active: true,
            description: "",
        };
    }

    async componentDidMount() {
        const environment = await EnvironmentStorage.getEnvironment();
        const response = await EnvironmentsAPI.getMetadataByEnvironmentId(
            environment.id
        );
    const {description} = response.getData({})
        this.setState({ description });
    }

    async updatedMetadataDescription(){
        const { description } = this.state;
        const environment = await EnvironmentStorage.getEnvironment();

        this.setState({ loading: true });

        const response = await EnvironmentsAPI.putMetadataByEnvironmentId(
            environment.id,
            {description:description}
        );

        if (response.error) {
            this.setState({ loading: false });
            return;
        }

        this.setState({ loading: false });
        this.props.onClose();
    }

    render() {
        const { loading } = this.state;
        const { visible, onClose } = this.props;

        return (
            <Drawer
                visible={visible}
                onClose={onClose}
                closeInFade
                title="Configurações SEO"
            >
                <div className={styles.secretDrawerContainer}>
                    <div className={styles.container}>
                        <Textarea
                            id="desc"
                            design="two"
                            placeholder="Descrição"
                            className="mt-20"
                            value={this.state.description}
                            onChange={(e) =>
                                this.setState({ description: e.target.value })
                            }
                        />
                    </div>
                    <div className={styles.footer}>
                        <Button
                            design="primary"
                            className="w-100"
                            onClick={() => this.updatedMetadataDescription()}
                            loading={loading}
                            disabled={loading}
                        >
                            Salvar
                        </Button>
                    </div>
                </div>
            </Drawer>
        );
    }
}
